
import { CharacterAddMinion, CharacterRemoveMinion, CharacterSaveMinion, CharacterUpdateMinion } from "../actions/CharacterMinionActions";
import { CharacterState } from "../CharacterStore.State";
import { CharacterReducerHelpers } from "./CharacterReducerHelpers";

const saveMinion = (state: CharacterState, action: CharacterSaveMinion): CharacterState => {
    const { characterId, oldInstanceId, newInstanceId } = action;
    const character = CharacterReducerHelpers.getCharacter(state, characterId);
    if (character == null) {
        return state;
    }

    const minion = character.minions.find(m => m.instanceId == oldInstanceId);
    if (minion == undefined) {
        console.error('Attempt to save nonexistent minion.');
        return state;
    }

    const newCharacter = {
        ...character,
        minions: [...character.minions.filter(m => m.instanceId != minion.instanceId), { ...minion, instanceId: newInstanceId }]
    };

    return CharacterReducerHelpers.updateCharacter(state, newCharacter);
}

const addMinion = (state: CharacterState, action: CharacterAddMinion): CharacterState => {
    const { characterId, reference } = action;
    const character = CharacterReducerHelpers.getCharacter(state, characterId);
    if (character == null) {
        return state;
    }

    if (character.minions.any(m => m.instanceId == reference.instanceId)) {
        console.error('Attempt to add duplicate minion.');
        return state;
    }

    const newCharacter = {
        ...character,
        minions: [...character.minions, reference]
    };

    return CharacterReducerHelpers.updateCharacter(state, newCharacter);
}

const removeMinion = (state: CharacterState, action: CharacterRemoveMinion): CharacterState => {
    const { characterId, minionInstanceId } = action;
    const character = CharacterReducerHelpers.getCharacter(state, characterId);
    if (character == null) {
        return state;
    }

    if (!character.minions.any(m => m.instanceId == minionInstanceId)) {
        console.error('Attempt to remove nonexistent minion.');
        return state;
    }

    const newCharacter = {
        ...character,
        minions: [...character.minions.filter(m => m.instanceId != minionInstanceId)]
    };

    return CharacterReducerHelpers.updateCharacter(state, newCharacter);
}

const updateMinion = (state: CharacterState, action: CharacterUpdateMinion): CharacterState => {
    const { characterId, reference } = action;
    const character = CharacterReducerHelpers.getCharacter(state, characterId);
    if (character == null) {
        return state;
    }

    if (!character.minions.any(m => m.instanceId == reference.instanceId)) {
        console.error('Attempt to update nonexistent minion.');
        return state;
    }
    
    const newCharacter = {
        ...character,
        minions: [...character.minions.filter(m => m.instanceId != reference.instanceId), reference]
    };

    return CharacterReducerHelpers.updateCharacter(state, newCharacter);
}

export const CharacterMinionReducers = {
    saveMinion,
    addMinion,
    removeMinion,
    updateMinion,
}